export const BASE_PRE_ONBOARDING = '/v1/pre-onboarding';

export const QUESTIONNAIRE_STORE_STATUS = `${BASE_PRE_ONBOARDING}/questionnaire-status`;
export const QUESTIONNAIRE_OPTIONS = `${BASE_PRE_ONBOARDING}/questionnaire-options`;
export const CREATE_QUESTIONNAIRE_STORE_PREFERENCES = `${BASE_PRE_ONBOARDING}/questionnaire-store-preferences`;
